import axios from 'axios';
import UtilityFunction from '../Util/Util';

const availableMethod = {
    get: 'get',
    post: 'post',
    put: 'put',
    delete: 'delete'
};

const {
    serializedURL,
    createRequestHash
} = UtilityFunction;

const apiCall = async (argPath, argMethod, argParam, argRequest, argHeaders) => {
    const apiUrl = process.env.REACT_APP_API_URL + argPath.replace(':param', argParam);
    let response = {};
    let serializedRequest = '';

    for( let index in argRequest ) {
        if( typeof argRequest === "string" ) {
            argRequest[index] = argRequest[index].replaceAll("+", " ");
        }
    }

    const createdHash = createRequestHash(argRequest);
    argRequest.hash = createdHash;

    try {
        if(argMethod === availableMethod.get) {
            serializedRequest = serializedURL(argRequest);
            let constructedUrl = `${apiUrl}?${serializedRequest}`;

            response = await axios.request({
                url: constructedUrl,
                // url: `${apiUrl}`,
                headers: { 
                    'Content-Type': 'application/json',
                    ...argHeaders
                },
                method: availableMethod.get,
                // data: argRequest
            });
        } else {
            if( argHeaders.hasOwnProperty('Content-Type') && argHeaders['Content-Type'] === 'multipart/form-data' ) {
                let tempRequest = {
                    ...argRequest
                };
                delete tempRequest.proof_of_transfer;
                delete tempRequest.design_attachment;
                argRequest.hash = createRequestHash(tempRequest);
            }

            response = await axios.request({
                url: `${apiUrl}`,
                headers: { 
                    'Content-Type': 'application/json',
                    ...argHeaders
                },
                method: argMethod,
                data: argRequest
            });
        }

        return response.data;
    } catch(e) {
        console.log(e.toString());
        return e.data;
    }

}

const getCall = async (argPath = '', argParam = null, argRequest = {}, argHeaders = {}) => {
    if(argPath === '') return false;

    for(let key in argRequest) {
        let value = argRequest[key];

        if(typeof value == 'object') {
            value = JSON.stringify(value);
        }

        argRequest[key] = value;
    }

    return await apiCall(argPath, availableMethod.get, argParam, argRequest, argHeaders);
}

const postCall = async (argPath = '', argParam = null, argRequest = {}, argHeaders = {}) => {
    if(argPath === '') return false;

    // for(let key in argRequest) {
    //     let value = argRequest[key];

    //     if(typeof value == 'object' || typeof value == 'array') {
    //         value = JSON.stringify(value);
    //     }

    //     argRequest[key] = value;
    // }

    return await apiCall(argPath, availableMethod.post, argParam, argRequest, argHeaders);
}


const putCall = async (argPath = '', argParam = null, argRequest = {}, argHeaders = {}) => {
    if(argPath === '') return false;

    // for(let key in argRequest) {
    //     let value = argRequest[key];

    //     if(typeof value == 'object' || typeof value == 'array') {
    //         value = JSON.stringify(value);
    //     }

    //     argRequest[key] = value;
    // }

    return await apiCall(argPath, availableMethod.put, argParam, argRequest, argHeaders);
}

const deleteCall = async (argPath = '', argParam = null, argRequest = {}, argHeaders = {}) => {
    if(argPath === '') return false;

    return await apiCall(argPath, availableMethod.delete, argParam, argRequest, argHeaders);
}

const api = {
    getCall,
    postCall,
    putCall,
    deleteCall
};

export default api;